export const normalize = (
  val: number,
  min: number,
  max: number,
  range: [number, number],
) => ((val - min) / (max - min)) * (range[1] - range[0]) + range[0];
